import {
  OrdersParticipantsTarget,
  OrderStatus,
} from "@/features/order/types.ts";

export const orderTools = {
  formatOrderId(number: number): string {
    return `SP-${number.toString().padStart(5, "0")}`;
  },
  status: {
    toString(status: OrderStatus): string {
      switch (status) {
        case "created":
          return "Клиент создал";
        case "cancelled":
          return "Отменен";
        case "accepted":
          return "Назначен на курьера (отправитель)";
        case "going_to_sender":
          return "Курьер выехал за посылкой";
        case "decided":
          return "Отклонено";
        case "submitted":
          return "Курьер принял";
        case "accounted":
          return "Принята на склад";
        case "checked":
          return "Прошла проверку на складе";
        case "revision":
          return "Возвращена на пересмотр";
        case "dispatched":
          return "Посылка отгружается";
        case "transit":
          return "В пути";
        case "arrived":
          return "Прибыл в город получателя";
        case "assigned":
          return "Назначен на курьера (получатель)";
        case "delivers_recipient":
          return "Курьер везет получателю";
        case "completed":
          return "Выполнен";
        default:
          return "";
      }
    },
  },
  participants: {
    target: {
      toString(status: OrdersParticipantsTarget): string {
        switch (status) {
          case "ORDER_INITIATOR":
            return "Отправляющий";
          case "ORDER_REVIEW_COURIER":
            return "Курьер";
          default:
            return "";
        }
      },
    },
  },
  address: {
    toString(props: {
      city: string;
      address: string;
      apartment?: string;
      floor?: string;
      entrance?: string;
    }) {
      const values: string[] = [props.city, props.address];

      if (props.apartment) values.push(props.apartment);
      if (props.floor) values.push(props.floor);
      if (props.entrance) values.push(props.entrance);

      return values.join(", ");
    },
  },
};
